import MembershipOffers from 'components/membershipOffers';

const MembershipOfferPage = () => {
  return <MembershipOffers />;
};

export default MembershipOfferPage;
